import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomChartService {
  constructor() {}

  @Output()
  updatePorfolioGraphValues: EventEmitter<any> = new EventEmitter();

  updateChartData(values) {
    this.updatePorfolioGraphValues.emit(values);
  }
}
